import { DOCS_URLS } from "@p0security/frontend-core";
import { AnnouncementBanner } from "components/common/AnnouncementBanner";
import React from "react";

export const PolicyOutlineNav: React.FC = () => (
  <AnnouncementBanner
    id="policy-editor-intro"
    message="A policy defines who can request access to what resources, and what actions should be taken."
    action={{ label: "Learn more", href: DOCS_URLS.JIT_POLICIES }}
  />
);
